import { defineComponent, PropType } from "vue";
import Utils from "../../utils/Utils";
import { OfferJson } from "../../OrderForm";
import StepSmeHome from "../../steps/sme/StepSmeHome";
import StepSmeNoNip from "../../steps/sme/StepSmeNoNip";
import StepSmeNipError from "../../steps/sme/StepSmeNipError";
import StepSmeVerify from "../../steps/sme/StepSmeVerify";
import StepSmeOffers from "../../steps/sme/StepSmeOffers";
import StepSmeForm from "../../steps/sme/StepSmeForm";
import StepSmeContact from "../../steps/sme/StepSmeContact";
import StepSmeOtherTariff from "../../steps/sme/StepSmeOtherTariff";
import StepSmeNipFound from "../../steps/sme/StepSmeNipFound";
import { SmeOrderJson } from "../../utils/SmeUtils";
import StepSmeNipReservation from "../../steps/sme/StepSmeNipReservation";
import StepSmeProsumer from "../../steps/sme/StepSmeProsumer";
import StepSmeMultiplePpe from "../../steps/sme/StepSmeMultiplePpe";
import StepSmeNoEnergySales from "../../steps/sme/StepSmeNoEnergySales";
import StepSmeUpload from "../../steps/sme/StepSmeUpload";

export default defineComponent({
    components: {
        StepSmeHome,
        StepSmeUpload,
        StepSmeNoNip,
        StepSmeNipError,
        StepSmeOtherTariff,
        StepSmeProsumer,
        StepSmeMultiplePpe,
        StepSmeNoEnergySales,
        StepSmeNipFound,
        StepSmeNipReservation,
        StepSmeVerify,
        StepSmeOffers,
        StepSmeForm,
        StepSmeContact,
    },

    template: `
        <StepSmeHome
            v-if="isStep('sme')"
            :options="options"
        />

        <StepSmeUpload
            v-if="isStep('sme.upload')"
            :options="options"

            @upload:next="onNext"
        />

        <StepSmeNoNip
            v-if="isStep('sme.nonip')"
            :options="options"

            @offers="setStep('offers.all')"
            @b2c="setStep('offers.details')"
        />

        <StepSmeNipError
            v-if="isStep('sme.niperror')"
            :options="options"
        />

        <StepSmeProsumer
            v-if="isStep('sme.prosumer')"
            :options="options"
        />

        <StepSmeNoEnergySales
            v-if="isStep('sme.noenergysales')"
            :options="options"

            @otherinvoice="setStep('sme')"
        />

        <StepSmeMultiplePpe
            v-if="isStep('sme.multipleppe')"
            :options="options"

            @otherinvoice="setStep('sme')"
        />

        <StepSmeNipFound
            v-if="isStep('sme.nipfound')"
        />

        <StepSmeNipReservation
            v-if="isStep('sme.nipreservation')"
        />

        <StepSmeOtherTariff
            v-if="isStep('sme.othertariff')"
        />

        <StepSmeVerify
            v-if="isStep('sme.verify')"
            :options="options"

            @accept="setStep('sme.offer', options.offer)"
        />

        <StepSmeOffers
            v-if="isStep('sme.offer')"
            :options="options"

            @back="setStep('sme.verify')"
            @offer="setStep('sme.form.verify', options.offer)"
        />

        <StepSmeForm
            v-if="isStep('sme.form*')"
            :options="options"
        />

        <StepSmeContact
            v-if="isStep('sme.contact')"
        />
    `,

    props: {
        options: { type: Object as PropType<SmeOrderJson>, required: true },
    },

    setup(props, ctx) {
        function isStep(val: string) {
            return Utils.isStep(val);
        }

        function setStep(step: string, offer?: OfferJson) {
            Utils.setStep(step, offer);
        }

        function onNext() {
            setStep(props.options.nextstep);
        }

        return {
            isStep,
            setStep,
            onNext,
        };
    },
});
